import {connect} from 'react-redux';
import Page from './Page';

const mapStateToProps = ({
                           user: {allowInspectionsShare, firmInspectionsAccess},
                         }) => ({
  allowInspectionsShare,
  firmInspectionsAccess
});

export default connect(
  mapStateToProps,
  null
)(Page);
